module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isCustom),
      callback: function($$v) {
        _vm.isCustom = $$v
      },
      expression: "isCustom"
    }
  }, [_vm._v("Custom")])], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableDataSimple
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "First Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.first_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Last Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Date",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.gender) + "\n                ")])]
      }
    }])
  }, [(!_vm.isCustom) ? _c('template', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "has-text-right"
  }, [_vm._v("\n                    Footer\n                ")])]) : _c('template', {
    slot: "footer"
  }, [_c('th', {
    staticClass: "is-hidden-mobile",
    staticStyle: {
      "width": "40px"
    }
  }, [_c('div', {
    staticClass: "th-wrap is-numeric"
  }, [_vm._v(" ID ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" First Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" Last Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap is-centered"
  }, [_vm._v(" Date ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" Gender ")])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9a2691e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExFooter.vue
// module id = 1225
// module chunks = 1 87